<template>
  <div class="text-left">
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header/>
    <b-container fluid>
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span class="fa fa-table"></span>
          <span>Posible garantia</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>S-00</div>
        </b-col>
      </b-row>

      <div class="divSubtitulo">
        <p class="textSubtitulo">Dictamen dental</p>
      </div>
      <b-row>
        <b-col>
          <informacion-queja :id-ticket.sync="idTicket"></informacion-queja>
        </b-col>
      </b-row>
      <b-form>
        <b-row>
          <b-col>
            <b-form-group>
              <label>Resolución:</label>
              <v-select
                  :reduce="(variable) => variable.id"
                  :options="resoluciones"
                  label="descripcion"
                  v-model="$v.form.idResolucion.$model"
                  :class="selectClass('idResolucion')"
              >

              </v-select>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group>
              <label>Tipo Garantia:</label>
              <v-select
                  :reduce="(variable) => variable.id"
                  :options="tipoQuejas"
                  multiple
                  label="descripcion"
                  v-model="$v.form.idTipoGarantia.$model"
                  :class="selectClass('idTipoGarantia')"
              >

              </v-select>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group>
              <label>OD en garantia:</label>
              <v-select
                  :options="dientes"
                  label="numeroDiente"
                  :reduce="(fin) => fin.idDiente"
                  v-model="$v.form.idDiente.$model"
                  :class="selectClass('idDiente')"
              >

              </v-select>
            </b-form-group>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <span v-if="datosAnteriores === null"></span>
          <b-col v-else cols="6" v-for="(diente,id) in datosAnteriores.dientes" :key="'dientea'+id">
            <div class="accordion" role="tablist">
              <b-card no-body class="mb-1">
                <b-card-header header-tag="header" v-b-toggle="'accordion-diente-a' + id" class="p-1" role="tab">
                  <b-row style="background-color: transparent !important; font-size: large">
                    <b-col>
                    </b-col>
                    <b-col class="text-center">
                      OD/Zona: <strong>{{ diente.numeroDiente }}</strong>
                    </b-col>
                    <b-col class="text-right">
                    </b-col>
                  </b-row>
                </b-card-header>
                <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <b-list-group>
                      <b-list-group-item v-for="(tx,it) in diente.tratamientos" :key="'Da'+id+'tratamiento'+it">
                        <b-row style="background-color: transparent !important; font-size: large">
                          <b-col cols="1">
                            {{ tx.idTratamiento }}
                          </b-col>
                          <b-col class="text-center">
                            <strong>{{ tx.nombre }}</strong>
                          </b-col>
                          <b-col cols="1" class="text-right">
                          </b-col>
                        </b-row>
                      </b-list-group-item>
                    </b-list-group>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </b-col>
          <b-col cols="6" v-for="(diente,id) in form.dientes" :key="'diente'+id">
            <div class="accordion" role="tablist">
              <b-card no-body class="mb-1">
                <b-card-header header-tag="header" v-b-toggle="'accordion-diente' + id" class="p-1" role="tab">
                  <b-row style="background-color: transparent !important; font-size: large">
                    <b-col>
                      <font-awesome-icon
                          v-b-tooltip.hover
                          title="Eliminar diente"
                          class="eliminar"
                          icon="times-circle"
                          @click="eliminarDiente(diente)"
                      />
                    </b-col>
                    <b-col class="text-center">
                      OD/Zona: <strong>{{ diente.numeroDiente }}</strong>
                    </b-col>
                    <b-col class="text-right">
                      <b-button variant="success" :disabled="diente.tratamientos.length >= 10"
                                @click="abrirModal(diente)">Agregar Tratamiento
                      </b-button>
                    </b-col>
                  </b-row>
                </b-card-header>
                <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <b-list-group>
                      <b-list-group-item v-for="(tx,it) in diente.tratamientos" :key="'D'+id+'tratamiento'+it">
                        <b-row style="background-color: transparent !important; font-size: large">
                          <b-col cols="1">
                            {{ tx.idTratamiento }}
                          </b-col>
                          <b-col class="text-center">
                            <strong>{{ tx.nombre }}</strong>
                          </b-col>
                          <b-col cols="1" class="text-right">
                            <font-awesome-icon
                                v-b-tooltip.hover
                                title="Eliminar tratamiento"
                                class="eliminar"
                                icon="times-circle"
                                @click="eliminarTratamiento(diente,tx)"
                            />
                          </b-col>
                        </b-row>
                      </b-list-group-item>
                    </b-list-group>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </b-col>
          <b-col cols="6">
            <span class="ml-auto mt-auto">
              <font-awesome-icon
                  v-b-tooltip.hover
                  title="Agregar diente"
                  style="font-size: xx-large;"
                  class="editar"
                  icon="plus-circle"
                  @click="abrirModalDientes()"
              />
            </span>

          </b-col>

        </b-row>
        <b-row>
          <b-col>
            <b-table
                id="Pendientes"
                thead-tr-class="columnas"
                empty-filtered-text="Sin resultados"

                :items="form.empleados"
                :fields="columnas"
                responsive="true"
                class="parrafos"
            >
              <template v-slot:cell(especialidad)="row">
                <b-badge pill variant="primary" v-for="(i,ind) in row.item.especialidades" :key="ind">{{ i }}</b-badge>
              </template>
              <template v-slot:cell(implicacion)="row">
                <v-select v-model="row.item.implicacion"
                          :class="selectClassArray('empleados',row.index,'implicacion')"
                          :reduce ="t => t.value"
                          label="text"
                          :options="implicaciones"></v-select>
              </template>
            </b-table>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-form-group>
              <label>Se sugiere para resolición de caso:</label>

              <v-select
                  :options="empleados"
                  multiple
                  label="nombreEmpleado"
                  :reduce="(fin) => fin.idEmpleado"
                  v-model="$v.form.sugerencia.$model"
                  :class="selectClass('sugerencia')"
              >
                <template v-slot:option="option">
                  <div style="max-width: 30vw">
                    <span style="display: grid;font-size: small">{{option.nombreEmpleado}}</span>
                    <span style="font-size: x-small">(<strong>{{option.nombreEspecialidades}}</strong>)</span>
                  </div>
                </template>
              </v-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="datosAnteriores != null">
          <b-col>
            <b-form-group>
              <label>Ruta comentada anteriormente:</label>
              <b-form-textarea
                  disabled
                  v-model="datosAnteriores.ruta"
                  :state="validateState('ruta')"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <label>Ruta:</label>
              <b-form-textarea
                  v-model="$v.form.ruta.$model"
                  :state="validateState('ruta')"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="datosAnteriores != null">
          <b-col>
            <b-form-group>
              <label>Notas Especiales comentadas anteriormente:</label>
              <b-form-textarea
                  disabled
                  v-model="datosAnteriores.notasEspeciales"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <label>Notas Especiales:</label>
              <b-form-textarea
                  v-model="$v.form.notasEspeciales.$model"
                  :state="validateState('notasEspeciales')"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="text-center">
            <boton-cancelar
                :variant="'primary'"
                :boton-text="'Emitir Dictamen'"
                :loader="loaderGuardar"
                :loading-text="'Emitiendo..'"
                @accion="guardar"
            >

            </boton-cancelar>
          </b-col>
        </b-row>

      </b-form>
    </b-container>
    <b-modal
        v-model="modalTx"
        title="Agregar Tratameinto"
        size="lg"
        hide-footer
        centered
    >
      <b-container fluid>
        <v-select
            :options="tratamientos"
            label="nombre"
            @input="agregarTratameinto"
        >
        </v-select>
      </b-container>
    </b-modal>
    <b-modal
        v-model="modalOD"
        title="Agregar OD"
        size="sm"
        hide-footer
        centered
    >
      <b-container fluid>
        <v-select
            :options="dientes"
            label="numeroDiente"
            :keys="(key)=> 'DienteSelect'+key"
            @input="agregarDiente"
        >
        </v-select>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
import Header from "@/components/Header";
import {GarantiaService} from "@/apiServices/garantias/GarantiaService";
import {CatalogosService} from "@/apiServices/catalogos/CatalogosService";
import {EmpleadoService} from "@/apiServices/empleado/EmpleadoService";
import {required} from "vuelidate/lib/validators";
import BotonCancelar from "@/components/BotonCancelar";
import InformacionQueja from "@/components/InformacionQueja";


export default {
  name: "DentalDictamen",
  components: {InformacionQueja, BotonCancelar, Header},
  data() {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      garantiaServicio: new GarantiaService(),
      catalogoServicio: new CatalogosService(),
      empleadoServicio: new EmpleadoService(),
      columnas: [
        {key: "empleado", label: "Imputado a", sortable: true},
        {key: "especialidad", label: "Especialidad", sortable: true},
        {key: "idEmpleado", label: "ID Doctor", sortable: true},
        {key: "implicacion", label: "Grado de implicación ", sortable: true},
      ],
      registros: [],
      empleados: [],
      implicaciones: [
        {value: 1, text: "Mayor"},
        {value: 2, text: "Menor"},
      ],
      datos: null,
      dientes: [],
      tratamientos: [],
      tipoQuejas: [],
      resoluciones: [],
      datosAnteriores: null,
      form: {
        idResolucion: null,
        idTipoGarantia: null,
        idDiente: null,
        dientes: [],
        empleados: [],
        sugerencia: null,
        ruta: null,
        notasEspeciales: null
      },
      modalTx: false,
      modalOD: false,
      loaderGuardar: false,
      dienteSeleccionado: null,
      idTicket: null,
      idEtapa: null,
    }
  },
  validations: {
    form: {
      idResolucion: {required},
      idTipoGarantia: {required},
      idDiente: {required},
      empleados: {
        $each: {
          implicacion: {required}
        }
      },
      sugerencia: {required},
      ruta: {required},
      notasEspeciales: {required}
    },
  },
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.idTicket = this.$route.params.id;
    this.idEtapa = this.$route.params.idEtapa;
    this.obtenerInformacionTicket();
    this.obtenerEmpleados();
    this.obtenerDientes();
    this.obtenerDictamen();
    this.obtenerTratamientos();
    this.obtenerTratamientos();
    this.obtenerMotivos();
    this.obtenerResoluciones();
    this.obtenerImputados();
  },
  methods: {
    obtenerInformacionTicket() {
      const parametros = {idTicket: this.idTicket}
      this.garantiaServicio.obtenerTicket(parametros).then((respuesta) => {
        this.datos = respuesta.data;
      });
    },
    obtenerDictamen() {
      const parametros = {idSolicitud: this.idTicket}
      this.garantiaServicio.obtenerDictamenAntarior(parametros).then((respuesta) => {
        this.datosAnteriores = respuesta.data;
        if (this.datosAnteriores !== null) {
          const aux = JSON.parse(JSON.stringify(this.datosAnteriores));

          aux.ruta = null;
          aux.dientes = [];
          aux.notasEspeciales = null;
          this.form = aux
        }


      });
    },
    obtenerEmpleados() {
      const parametros = {idClinica: -1}
      this.$http
          .post(
              this.$api +
              "diagnostico/hoja/listaDoctoresEspecialistas", parametros
          )
          .then((response) => {
            this.empleados = response.data.data;
          });
    },
    obtenerResoluciones() {
      this.garantiaServicio.obtenerResoluciones().then((respuesta) => {
        this.resoluciones = respuesta.data;
      });
    },
    obtenerImputados() {
      const parametros = {idSolicitud: this.idTicket}
      this.garantiaServicio.obtenerImputados(parametros).then((respuesta) => {
        this.form.empleados = respuesta.data
      });
    },
    obtenerDientes() {
      this.catalogoServicio.obtenerDientes().then((response) => {
        this.dientes = response.data;
      });
    },
    obtenerTratamientos() {
      this.catalogoServicio
          .obtenerTratamientosConEspecilidades()
          .then((response) => {
            this.tratamientos = response;
          });
    },
    obtenerMotivos() {
      this.garantiaServicio.obtenerTipoGarantiaDental()
          .then(response => {
            this.tipoQuejas = response.data
          })
    },
    agregarTratameinto(tratamiento) {
      this.dienteSeleccionado.tratamientos.push(tratamiento);
      this.modalTx = false
    },
    eliminarDiente(diente) {
      this.form.dientes.splice(this.form.dientes.indexOf(diente), 1);
    },
    eliminarTratamiento(diente, tratamiento) {
      diente.tratamientos.splice(diente.tratamientos.indexOf(tratamiento), 1);
    },
    abrirModal(diente) {
      this.dienteSeleccionado = diente;
      this.modalTx = true;
    },
    abrirModalDientes() {
      this.modalOD = true;
    },
    agregarDiente(diente) {
      diente.tratamientos = []
      this.form.dientes.push(diente)
      this.modalOD = false
    },
    validateState(name) {
      const {$dirty, $error} = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    validateStateArray(name, index, name2) {
      const {$dirty, $error} = this.$v.form[name].$each[index][name2];
      return $dirty ? !$error : null;
    },
    selectClass(attribute) {
      let state = this.validateState(attribute);
      if (state) {
        return "border rounded-lg border-success";
      } else if (state === false) {
        return "border rounded-lg border-danger";
      } else {
        return "";
      }
    },
    selectClassArray(name, index, name2) {
      let state = this.validateStateArray(name, index, name2);
      if (state) {
        return "border rounded-lg border-success";
      } else if (state === false) {
        return "border rounded-lg border-danger";
      } else {
        return "";
      }
    },
    guardar() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return false;
      }
      this.form.ccee = true;
      this.loaderGuardar = true
      this.garantiaServicio.guardarDictamenDental(this.idTicket, this.idEtapa, this.$localStorageService.getIdEmpleado(), this.form)
          .then(() => {
            this.$swal({
              icon: "success",
              title: "Se registro correctamente",
              showConfirmButton: false
            });
            this.$v.$reset()
            window.history.back();
          })
          .finally(() => {
            this.loaderGuardar = false;
          })
    }
  }
}
</script>

<style scoped>

</style>
